core.constant('myDataMeedyTranslationPL', {
  "T": {
    "MEEDY": {
      "SYSTEM": {
        "MESSAGE": {
        }
      },
      "UI": {
        "TAB": {
          "MY_DATA" : "Moje dane",
          "OFFICES" : "Gabinety",
          "PRICE_LIST": "Cennik",
          "AVAILABILITY" : "Dostępność",
          "EDM_DOCUMENTS" : "Dokumenty EDM",
          "USERS" : "Recepcja",
          "MOBILE_DEVICES" : "Urządzenia mobilne",
          "ACCOUNT": "Konto"
        },
        "BREADCRUMB": {
        },
        "APPLICATION" : {
          "SETTINGS" : "Ustawienia"
        }
      },
      "MODULE": {
        "TITLE": {
        },
        "SETTINGS": {
          "SETTINGS": "Ustawienia"
        },
        "MY_DATA": {
          "INFORMATION_ABOUT_YOURSELF" : "Informacja o sobie",
          "ALLOW_CHILDREN" : "Przyjmuje dzieci",
          "FIRST_SPECIALIZATION" : "Specjalizacja 1",
          "SECOND_SPECIALIZATION" : "Specjalizacja 2",
          "YEAR" : "roku",
          "YEARS" : "lat",
          "FROM" : "Od",
          "TO" : "Do",
          "FIRST_NAME" : "Imię",
          "LAST_NAME" : "Nazwisko",
          "ACADEMIC_TITLE" : "Tytuł naukowy",
          "PESEL" : "PESEL",
          "PWZ" : "Prawo do wykonywania zawodu",
          "ZUS_CERTYFICATE" : "Certyfikat ZUS",
          "POST_CERTYFICATES" : "Certyfikaty placówki do e-recepty",
          "ADD_CERTIFICATE": "Dodaj Certyfikat",
          "ADD_CERTIFICATE_TLS": "Dodaj Certyfikat TLS",
          "ADD_CERTIFICATE_WSS": "Dodaj Certyfikat WSS",
          "CHANGE_CERTIFICATE": "Zmień certyfikat",
          "CHANGE_CERTIFICATE_TLS": "Zmień certyfikat TLS",
          "CHANGE_CERTIFICATE_WSS": "Zmień certyfikat WSS",
          "DELETE_CERTIFICATE": "Usuń certyfikat",
          "DELETE_CERTIFICATES": "Usuń certyfikaty",
          "CERTIFICATE_EXIST": "Certyfikat poprawnie wgrany",
          "CERTIFICATES_EXIST": "Certyfikaty (TLS, WSS) poprawnie wgrane",
          "EMAIL" : "Email",
          "PHONE" : "Numer telefonu komórkowego",
          "WORKING_AT_HOSPITAL" : "Aktualna praca w szpitalu",
          "SHORT_EXPERIENCE_DESCRIPTION" : "Krótki opis doświadczenia",
          "COMPANY_PRACTICE_DATA" : "Dane działalności/praktyki",
          "COMPANY_PRACTICE_FULL_NAME" : "Pełna nazwa działalności/praktyki",
          "COMPANY_PRACTICE" : "Działalność/praktyki",
          "OTHER" : "Inny",
          "OFFICE" : "Gabinet",
          "STREET" : "Ulica",
          "STREET_NUMBER" : "Nr domu",
          "OID_NUMBER" : "Numer OID",
          "RESORT_CODE_I" : "Kod resortowy I",
          "MEDICAL_POST_REGON" : "Numer REGON zakładu leczniczego",
          "FLAT_NUMBER" : "Numer mieszkania",
          "POST_CODE" : "Kod pocztowy",
          "CITY" : "Miasto",
          "STATE" : "Województwo",
          "CORRESPONDENCE_ADDRESS" : "Adres korespondencyjny",
          "BILLING_DATA" : "Dane rozliczeniowe",
          "BANK_ACCOUNT_NUMBER" : "Nr rachunku bankowego",
          "BANK_NAME" : "Nazwa banku",
          "INVALID_PESEL" : "Niepoprawny PESEL",
          "INVALID_ACCURATE_LENGTH" : "Numer musi składać się dokładnie z {{length}} cyfr",
          "REQUIRED_FIELD" : "Pole wymagane",
          "UNDER" : "poniżej",
          "WRONG_AGE_RANGE" : "Podane zakresy lat są niepoprawne",
          "ABOVE" : "powyżej",
          "NIP" : "NIP",
          "PHYSICIAN_NIP" : "NIP LEKARZA",
          "REGON" : "REGON",
          "ADD_ACADEMIC_TITLE" : "Dodaj nowy tytuł akademicki",
          "NOT_FOUND" : "Nie znaleziono tytułu {{text}}.",
          "DUPLICATED_PWZ" : "Numer PWZ już istnieje w systemie",
          "DUPLICATED_REGON" : "Numer REGON już istnieje w systemie",
          "DUPLICATED_NIP" : "Numer NIP już istnieje w systemie",
          "PICTURE": "Zdjęcie",
          "CURRENT": "Obecne",
          "CROPPING": "Kadrowanie",
          "NEW": "Nowe",
          "ALERT_STH_GOES_WRONG": "Nie udało się dodać certyfikatów. Sprawdź wprowadzone dane i spróbuj ponownie.",
          "DELETE_CERT" : "Czy na pewno chcesz usunąć certyfikat",
          "DELETE_CERTS" : "Czy na pewno chcesz usunąć certyfikaty",
          "SIGN_CERTS" : "Podpisz certyfikaty",
          "GET_PASSWORD" : "Podaj hasło do certyfikatów",
          "MEDICAL_CHAMBER":  "Okręgowa izba lekarska",
          "MEDICAL_TYPE": "Typ placówki",
          "CLINIC": "Placówka medyczna",
          "PRIVATE_PRACTICE": "Prywatna opieka",
          "MEDICAL_CHAMBER_ENTRY_NUMBER": "Numer nadany przez okręgową izbę lekarską"
        }
      }
    }
  }
});
